import React from 'react';
import { useState, useEffect, useContext, useMemo } from 'react';
import { AppContext } from "../../utils/ContextProvider";
import Loader from "../../components/Loader";
import { useLocation, Link, useNavigate } from 'react-router-dom';
import './style.css'
import API from '../../utils/API';
import Swal from 'sweetalert2';
import GlobalSVG from '../../utils/GlobalSVG';
import SlideToggle from '../../components/SlideToggle';
import UtilityBills from '../UtilityBills';
import { uploadAndScan } from '../../utils/utils';
import moment from 'moment';
import FilterableSelect from '../../components/FilterableSelect';

const Building = () => {

    const location = useLocation();
    const [building, setBuilding] = useState(null)
    const [clients, setClients] = useState(null)
    const [operators, setOperators] = useState(null)
    const [buildingTypes, setBuildingTypes] = useState(null)
    const [manager, setManager] = useState(false)
    const [tab, setTab] = useState(0)
    const [getPutPost, setGetPutPost] = useState()
    const [buildingData, setBuildingData] = useState({
        building_id: "",
        property_id: "",
        client_id: "",
        building: "",
        address: "",
        city: "",
        province: "",
        postalcode: "",
        country: "",
        timezone: "",
        latitude: "",
        longitude: "",
        sq_footage: "",
        eui_building_type_id: "",
        year_built: "",
        image: "",
        rep_name: "",
        rep_phone: "",
        rep_email: "",
        rep_image: "",
        has_operating_hours: true
    })
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const context = useContext(AppContext)
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const CA_PROVINCES = ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"];
    const US_STATES = [
        "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
        "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
        "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
        "VA", "WA", "WV", "WI", "WY", "DC"
    ];
    const POSTAL_FORMATS = {
        "Canada": {
            regex: /^[A-Z]\d[A-Z] \d[A-Z]\d$/,
            placeholder: "A1A 1A1",
            maxLength: 7,
            inputMode: "text",
            normalize: (v) => {
                const clean = v.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6);
                return clean.length > 3 ? `${clean.slice(0, 3)} ${clean.slice(3)}` : clean;
            },
        },
        "United States of America": {
            regex: /^\d{5}(-\d{4})?$/,
            placeholder: "12345 or 12345-6789",
            maxLength: 10,
            inputMode: "numeric",
            normalize: (v) => {
                const digits = v.replace(/\D/g, "").slice(0, 9);
                return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
            },
        },
    };

    const getPostalCodeError = (code, country) => {
        const fmt = POSTAL_FORMATS[country];
        if (!code || !fmt) return null; // field is optional; no country = nothing to check
        return fmt.regex.test(code) ? null : `Invalid format, expected ${fmt.placeholder}`;
    };

    const postalFormat = POSTAL_FORMATS[buildingData.country];

    const updatePostalCode = (e) => {
        const raw = e.target.value;
        const value = postalFormat ? postalFormat.normalize(raw) : raw.trim();
        setBuildingData(prev => ({ ...prev, postalcode: value }));
        // clear a stale error while they fix it
        setError(prev => (prev?.postalcode ? { ...prev, postalcode: undefined } : prev));
    };

    const validatePostalCode = () => {
        const msg = getPostalCodeError(buildingData.postalcode, buildingData.country);
        if (msg) setError(prev => ({ ...prev, postalcode: [msg] }));
    };



    const timezoneOptions = useMemo(() => {
        const FALLBACK_TIMEZONES = [
            "America/Toronto", "America/Vancouver", "America/Edmonton", "America/Winnipeg",
            "America/Regina", "America/Halifax", "America/St_Johns", "America/New_York",
            "America/Chicago", "America/Denver", "America/Los_Angeles", "America/Anchorage",
            "Pacific/Honolulu", "UTC"
        ];
        const ALL_TIMEZONES = (() => {
            try {
                return Intl.supportedValuesOf('timeZone');
            } catch (e) {
                return FALLBACK_TIMEZONES;
            }
        })();

        const PROVINCE_STATE_TIMEZONES = {
            // Canada
            AB: ["America/Edmonton"],
            BC: ["America/Vancouver", "America/Dawson_Creek", "America/Creston", "America/Fort_Nelson"],
            MB: ["America/Winnipeg"],
            NB: ["America/Moncton"],
            NL: ["America/St_Johns", "America/Goose_Bay"],
            NS: ["America/Halifax", "America/Glace_Bay"],
            NT: ["America/Yellowknife", "America/Inuvik"],
            NU: ["America/Iqaluit", "America/Rankin_Inlet", "America/Resolute", "America/Cambridge_Bay"],
            ON: ["America/Toronto", "America/Nipigon", "America/Thunder_Bay", "America/Rainy_River"],
            PE: ["America/Halifax"],
            QC: ["America/Toronto", "America/Blanc-Sablon"],
            SK: ["America/Regina"],
            YT: ["America/Whitehorse"],

            // United States
            AL: ["America/Chicago"],
            AK: ["America/Anchorage", "America/Juneau", "America/Sitka", "America/Metlakatla", "America/Yakutat", "America/Nome", "America/Adak"],
            AZ: ["America/Phoenix", "America/Denver"], // Navajo Nation observes DST, rest of AZ doesn't
            AR: ["America/Chicago"],
            CA: ["America/Los_Angeles"],
            CO: ["America/Denver"],
            CT: ["America/New_York"],
            DE: ["America/New_York"],
            FL: ["America/New_York", "America/Chicago"],
            GA: ["America/New_York"],
            HI: ["Pacific/Honolulu"],
            ID: ["America/Boise", "America/Los_Angeles"],
            IL: ["America/Chicago"],
            IN: ["America/Indiana/Indianapolis", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Vevay", "America/Indiana/Tell_City", "America/Indiana/Knox", "America/Chicago"],
            IA: ["America/Chicago"],
            KS: ["America/Chicago", "America/Denver"],
            KY: ["America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Chicago"],
            LA: ["America/Chicago"],
            ME: ["America/New_York"],
            MD: ["America/New_York"],
            MA: ["America/New_York"],
            MI: ["America/Detroit", "America/Menominee"],
            MN: ["America/Chicago"],
            MS: ["America/Chicago"],
            MO: ["America/Chicago"],
            MT: ["America/Denver"],
            NE: ["America/Chicago", "America/Denver"],
            NV: ["America/Los_Angeles"],
            NH: ["America/New_York"],
            NJ: ["America/New_York"],
            NM: ["America/Denver"],
            NY: ["America/New_York"],
            NC: ["America/New_York"],
            ND: ["America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/North_Dakota/Beulah", "America/Denver"],
            OH: ["America/New_York"],
            OK: ["America/Chicago"],
            OR: ["America/Los_Angeles", "America/Boise"],
            PA: ["America/New_York"],
            RI: ["America/New_York"],
            SC: ["America/New_York"],
            SD: ["America/Chicago", "America/Denver"],
            TN: ["America/New_York", "America/Chicago"],
            TX: ["America/Chicago", "America/Denver"],
            UT: ["America/Denver"],
            VT: ["America/New_York"],
            VA: ["America/New_York"],
            WA: ["America/Los_Angeles"],
            WV: ["America/New_York"],
            WI: ["America/Chicago"],
            WY: ["America/Denver"],
            DC: ["America/New_York"],
        };
        const provinceZones = PROVINCE_STATE_TIMEZONES[buildingData?.province];
        if (provinceZones) return provinceZones.filter(zone => ALL_TIMEZONES.includes(zone));

    }, [buildingData?.province]);

    useEffect(() => {
        if (!context.getUserInfo) return
        let access = ["access_buildings_and_operators_list", "create_buildings_and_operators", "update_buildings_and_operators"]
        if (!access.some(item => context.getUserInfo[item] === true)) {
            navigate('/map')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.getUserInfo])

    useEffect(() => {
        if (getPutPost === 'put') return
        if (location.pathname === '/building/create') {
            setGetPutPost('post')
        } else if (queryParams.size !== 0) {
            setBuilding(queryParams.get('building'))
            setGetPutPost('get')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryParams, location])

    useEffect(() => {
        const cancelToken = API.cancelToken();
        if (getPutPost === 'get' && building !== null) {
            setLoading(true)

            API.getBuildingBasic(cancelToken, building).then(res => {
                setLoading(false)
                setBuildingData(res.data)
                return
            }).catch(err => {
                setLoading(false)
                console.log(err)
                if (err.message === 'cancelling') return
                if (err.response && err.response.data) {
                    try {
                        if (err.response.data.includes('error')) {
                            Swal.fire({
                                title: 'Error.',
                                text: err.response.data.error,
                                icon: 'warning',
                                confirmButtonText: 'Ok',
                                confirmButtonColor: '#007b4e',
                            });
                        }
                    } catch (e) {
                        Swal.fire({
                            title: 'Error.',
                            text: err.response.data,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    }
                } else {
                    Swal.fire({
                        title: 'Error.',
                        text: 'An error occurred, please try again later.',
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                }
            })

        }
        API.getEuiTypes(cancelToken).then(res => {
            setLoading(false)
            setBuildingTypes(res.data)
            return
        }).catch(err => {
            setLoading(false)
            console.log(err)
            if (err.message === 'cancelling') return
            if (err.response && err.response.data) {
                try {
                    if (err.response.data.includes('error')) {
                        Swal.fire({
                            title: 'Error.',
                            text: err.response.data.error,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    }
                } catch (e) {
                    Swal.fire({
                        title: 'Error.',
                        text: err.response.data,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                }
            } else {
                Swal.fire({
                    title: 'Error.',
                    text: 'An error occurred, please try again later.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
            }
        })
        return () => {
            API.cancel(cancelToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getPutPost, building])

    useEffect(() => {
        if (!context.getUserInfo) return
        const cancelToken = API.cancelToken();

        API.getClients(cancelToken).then(res => {
            setClients(res.data)
            return
        }).catch(err => {
            console.log(err)
            if (err.message === 'cancelling') return
            Swal.fire({
                title: 'Error.',
                text: 'Please try again later.',
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e',
            });

        })
        API.getOperators(cancelToken).then(res => {
            setOperators(res.data)
            return
        }).catch(err => {
            console.log(err)
            if (err.message === 'cancelling') return
            Swal.fire({
                title: 'Error.',
                text: 'Please try again later.',
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e',
            });

        })

        return () => {
            API.cancel(cancelToken);
        }
    }, [context.getUserInfo])

    const updateBuilding = async (e) => {
        const { name, type, value, checked, files } = e.target;
        if (type === 'file') {
            const selectedImage = await Promise.all(
                Array.from(files).map(file =>
                    new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = (e) => resolve({
                            name: file.name,
                            type: file.type,
                            size: file.size,
                            data: e.target.result
                        });
                        reader.readAsDataURL(file);
                    })
                )
            );

            setBuildingData(prevValue => {
                return {
                    ...prevValue,
                    [name]: selectedImage
                }
            })
            return

        }
        if (type === 'checkbox') {
            setBuildingData(prev => ({ ...prev, [name]: checked }));
            return;
        }

        setBuildingData(prevValue => {
            return {
                ...prevValue,
                [name]: value.trim()
            }
        })

    }

    const FIELDS_TO_REMOVE = [
        'client_name', 'devices', 'e_channels', 'hierarchy', 'w_channels',
        'e_sources', 'operating_hours', 'w_hierarchy', 'g_channels', 'g_hierarchy',
        'created_at', 'updated_at', 'w_sources', 'alerts', 'g_sources', 'actuators',
        'bills_only', 'e_channels_untracked', 'building_type'
    ];

    const showErrorAlert = (message) => {
        Swal.fire({
            title: 'Error.',
            text: message,
            icon: 'warning',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#007b4e',
        });
    };

    const sanitizePayload = (data, isPost) => {
        const payload = JSON.parse(JSON.stringify(data));

        FIELDS_TO_REMOVE.forEach((field) => delete payload[field]);
        if (!isPost) delete payload['building_id'];

        for (const [key, value] of Object.entries(payload)) {
            if (value === null || String(value).trim() === '') {
                delete payload[key];
            } else if (key === 'sq_footage') {
                payload[key] = Math.round(parseFloat(value));
            }
        }

        return payload;
    };

    const resolveImageField = async (payload, field) => {
        const value = payload[field];
        if (!value) return true;

        if (value.includes('https')) {
            delete payload[field];
            return true;
        }

        const fieldLabel = field === 'image' ? 'building image' : 'building rep image';
        const id = await uploadAndScan(value, fieldLabel);

        if (id.length) payload[field] = id[0]
        else {
            delete payload[field]
            return false
        }

        return true;
    };

    const postBuilding = async () => {
        if (!buildingData.building) {
            setError({ building: 'Missing Value' });
            return;
        }

        const pcError = getPostalCodeError(buildingData.postalcode, buildingData.country);
        if (pcError) {
            setError({ postalcode: [pcError] });
            return;
        }


        setLoading(true);

        const isPost = getPutPost === 'post';
        const payload = sanitizePayload(buildingData, isPost);
        const cancelToken = API.cancelToken();

        const imageResolved = await resolveImageField(payload, 'image');
        if (!imageResolved) {
            setLoading(false)
            return
        };

        const repImageResolved = await resolveImageField(payload, 'rep_image');
        if (!repImageResolved) {
            setLoading(false)
            return
        };

        payload.operators = buildingData.operators?.map((op) => op.operator_id) ?? [];


        try {
            if (isPost) {
                await API.postBuilding(cancelToken, payload);
                navigate(`/building?building=${buildingData.building_id}`);
            } else {
                payload['data_collection'] = moment(payload['data_collection']).format("YYYY-MM-DD")
                await API.putBuilding(cancelToken, building, payload);
                setGetPutPost('get');
                setError(null);
            }
        } catch (err) {
            if (err.message === 'cancelling') return;

            const errorMessage =
                err.response?.data?.error ??
                (typeof err.response?.data === 'string' ? err.response.data : null) ??
                'An error occurred, please try again later.';

            setError(err.response?.data ?? null);
            showErrorAlert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const updateOperators = (operator) => {
        let inList = buildingData.operators.find(e => e.operator_id === operator.operator_id)
        let tempData = JSON.parse(JSON.stringify(buildingData))
        if (!inList) {
            tempData.operators.push(operator)
        } else {
            tempData.operators = tempData.operators.filter(e => e.operator_id !== operator.operator_id);
        }
        setBuildingData(tempData)
    }

    return (
        <div className='tablet:p-8 mobile:p-3 min-h-[80vh]'>
            <div className='flex flex-nowrap items-center gap-4 tablet:mb-8 mobile:mb-3 text-base'>
                <Link to="/settings/buildings">
                    Buildings
                </Link>
                {
                    GlobalSVG.rightArrow()
                }
                <p className='font-medium'>
                    {
                        ['get', 'put'].includes(getPutPost) ? buildingData.building : "Add Building"

                    }
                </p>
            </div>
            <div className='card tablet:p-8 mobile:p-3 min-h-[70vh]'>
                <div className="flex flex-wrap items-center justify-between text-3xl p-2 w-full">
                    <div className='items-center mb-2 laptop:w-1/2 tablet:w-full mobile:'>
                        <input
                            placeholder='Building Name'
                            className='text-3xl p-2 outline-none hide-input-background w-full'
                            type="text"
                            name='building'
                            disabled={getPutPost === 'get'}
                            defaultValue={buildingData.building ? buildingData.building : ""}
                            onChange={updateBuilding} />
                        {
                            error && error.building &&
                            <p className='text-red text-xs p-2'>{error.building}</p>

                        }
                    </div>
                    {tab === 0 &&
                        <div className="flex flex-nowrap items-center justify-center mb-6">
                            <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color mt-2' htmlFor="active">Active</label>
                            <SlideToggle disabled={getPutPost === 'get'} setOptions={setBuildingData} options={buildingData} id={"active"} />
                        </div>
                    }
                </div>
                <div className="input-border p-4">
                    <div className="flex flex-norwap justify-start items-center gap-8 mb-4">
                        <div onClick={() => setTab(0)} className={`${tab === 0 ? "active-factor" : "inactive-factor"} font-normal text-base leading-5 pb-1 font-bold cursor-pointer`}>Building Info</div>
                        <div onClick={() => setTab(1)} className={`${tab === 1 ? "active-factor" : "inactive-factor"} font-normal text-base leading-5 pb-1 font-bold cursor-pointer`}>Utility Bills</div>
                    </div>
                </div>
                {
                    loading &&
                    <Loader />
                }
                {tab === 1 &&
                    <UtilityBills building={building} />
                }
                {tab === 0 &&
                    <div>
                        <div className='flex flex-wrap'>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="building_id">Building ID</label>
                                    <input
                                        placeholder='Building ID'
                                        className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                        type="text"
                                        name="building_id" defaultValue={buildingData.building_id ? buildingData.building_id : ""}
                                        disabled={getPutPost !== 'post'}
                                        onChange={updateBuilding} />
                                    {
                                        error && error.building_id &&
                                        <p className='text-red text-xs'>{error.building_id[0]}</p>

                                    }
                                </div>
                            </div>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="image">Building Image</label>
                                    {
                                        getPutPost === 'get' &&
                                        <img className='w-20' src={buildingData.image ? buildingData.image : require('../../assets/images/placeholder-image.png')} alt="" />
                                    }
                                    {getPutPost !== 'get' &&
                                        <input
                                            className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                            type="file"
                                            name="image"
                                            onChange={updateBuilding} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-wrap'>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="property_id">Property ID</label>
                                    <input
                                        placeholder='Property ID'
                                        className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                        type="text"
                                        name="property_id" defaultValue={buildingData.property_id ? buildingData.property_id : ""}
                                        disabled={getPutPost === 'get'}
                                        onChange={updateBuilding} />
                                    {
                                        error && error.property_id &&
                                        <p className='text-red text-xs'>{error.property_id[0]}</p>

                                    }
                                </div>
                            </div>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="client_id">Client ID</label>
                                    <select
                                        className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                        name="client_id"
                                        value={buildingData.client_id ? buildingData.client_id : ""}
                                        disabled={getPutPost === 'get'}
                                        onChange={updateBuilding}
                                    >
                                        <option value="">Select</option>
                                        {
                                            clients && clients.map((e, idx) => (
                                                <option key={idx + 'clientidkey'} value={e.client_id}>{e.client_id}</option>
                                            ))
                                        }
                                    </select>
                                    {
                                        error && error.client_id &&
                                        <p className='text-red text-xs'>{error.client_id[0]}</p>

                                    }
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-wrap'>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="address">Address</label>
                                    <input
                                        placeholder='Address'
                                        className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                        type="text"
                                        name="address" defaultValue={buildingData.address ? buildingData.address : ""}
                                        disabled={getPutPost === 'get'}
                                        onChange={updateBuilding} />
                                    {
                                        error && error.address &&
                                        <p className='text-red text-xs'>{error.address[0]}</p>

                                    }
                                </div>
                            </div>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="city">City</label>
                                    <input
                                        placeholder='City'
                                        className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                        type="text"
                                        name="city" defaultValue={buildingData.city ? buildingData.city : ""}
                                        disabled={getPutPost === 'get'}
                                        onChange={updateBuilding} />
                                    {
                                        error && error.city &&
                                        <p className='text-red text-xs'>{error.city[0]}</p>

                                    }
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-wrap'>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="country">Country</label>
                                    <select
                                        className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color'
                                        name="country"
                                        disabled={getPutPost === 'get'}
                                        onChange={updateBuilding}
                                        value={buildingData.country ? buildingData.country : ""}>
                                        <option value="">Country</option>
                                        <option value="Canada">Canada</option>
                                        <option value="United States of America">United States of America</option>

                                    </select>
                                    {
                                        error && error.country &&
                                        <p className='text-red text-xs'>{error.country[0]}</p>

                                    }
                                </div>
                            </div>
                            <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                <div className='w-full flex flex-wrap items-center'>
                                    <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="postalcode">Postal Code</label>
                                    <input
                                        placeholder={postalFormat?.placeholder ?? "Select a country first"}
                                        className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                        type="text"
                                        name="postalcode"
                                        value={buildingData.postalcode ?? ""}
                                        maxLength={postalFormat?.maxLength}
                                        inputMode={postalFormat?.inputMode}
                                        autoCapitalize="characters"
                                        disabled={getPutPost === 'get'}
                                        onChange={updatePostalCode}
                                        onBlur={validatePostalCode} />
                                    {
                                        postalFormat && getPutPost !== 'get' &&
                                        <p className='w-full text-xs input-label-color'>Format: {postalFormat.placeholder}</p>
                                    }
                                    {
                                        error && error.postalcode &&
                                        <p className='text-red text-xs'>{error.postalcode[0]}</p>
                                    }
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 pr-4 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="province">Province</label>
                                        <FilterableSelect
                                            options={
                                                buildingData?.country === "Canada" ? CA_PROVINCES :
                                                    buildingData?.country === "United States of America" ? US_STATES :
                                                        []
                                            }
                                            disabled={getPutPost === 'get'}
                                            placeholder="Select"
                                            name="province"
                                            value={buildingData.province ? buildingData.province : ""}
                                            onChange={updateBuilding}
                                        />
                                        {
                                            error && error.province &&
                                            <p className='text-red text-xs'>{error.province[0]}</p>

                                        }
                                    </div>
                                </div>

                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 pr-4 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <div className='w-full flex flex-wrap items-center'>
                                            <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="timezone">Timezone</label>
                                            <FilterableSelect
                                                options={timezoneOptions}
                                                disabled={getPutPost === 'get'}
                                                placeholder="Select"
                                                name="timezone"
                                                value={buildingData.timezone ? buildingData.timezone : ""}
                                                onChange={updateBuilding}
                                            />
                                            {
                                                error && error.timezone &&
                                                <p className='text-red text-xs'>{error.timezone[0]}</p>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="latitude">Latitude</label>
                                        <input
                                            placeholder='Latitude'
                                            className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                            type="number"
                                            step="0.1"
                                            name="latitude" defaultValue={buildingData.latitude ? buildingData.latitude : ""}
                                            disabled={getPutPost === 'get'}
                                            onChange={updateBuilding} />
                                        {
                                            error && error.latitude &&
                                            <p className='text-red text-xs'>{error.latitude[0]}</p>

                                        }
                                    </div>
                                </div>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <div className='w-full flex flex-wrap items-center'>
                                            <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="longitude">Longitude</label>
                                            <input
                                                placeholder='Longitude'
                                                className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="number"
                                                step="0.1"
                                                name="longitude" defaultValue={buildingData.longitude ? buildingData.longitude : ""}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.longitude &&
                                                <p className='text-red text-xs'>{error.longitude[0]}</p>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="sq_footage">Square Footage</label>
                                        <input
                                            placeholder='Square Footage'
                                            className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                            type="number"
                                            step="1"
                                            name="sq_footage" defaultValue={buildingData.sq_footage ? buildingData.sq_footage : ""}
                                            disabled={getPutPost === 'get'}
                                            onChange={updateBuilding} />
                                        {
                                            error && error.sq_footage &&
                                            <p className='text-red text-xs'>{error.sq_footage[0]}</p>

                                        }
                                    </div>
                                </div>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <div className='w-full flex flex-wrap items-center'>
                                            <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="eui_building_type_id">EUI Building Type</label>
                                            <select
                                                className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                name="eui_building_type_id"
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding}
                                                value={buildingData.eui_building_type_id ? buildingData.eui_building_type_id : ""}>
                                                <option value="">EUI Building Type</option>
                                                {
                                                    buildingTypes && buildingTypes.map((t, ix) => (
                                                        <option key={'euitypes' + ix} value={t.id}>{t.building_type}</option>
                                                    ))
                                                }
                                            </select>
                                            {
                                                error && error.eui_building_type_id &&
                                                <p className='text-red text-xs'>{error.eui_building_type_id[0]}</p>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="year_built">Year Built</label>
                                        <input
                                            placeholder='Year Built'
                                            className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                            type="number"
                                            step="1"
                                            name="year_built" defaultValue={buildingData.year_built ? buildingData.year_built : ""}
                                            disabled={getPutPost === 'get'}
                                            onChange={updateBuilding} />
                                        {
                                            error && error.year_built &&
                                            <p className='text-red text-xs'>{error.year_built[0]}</p>

                                        }
                                    </div>
                                </div>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <div className='w-full flex flex-wrap items-center'>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="rep_name">Rep. Name</label>
                                        <input
                                            placeholder='Rep. Name'
                                            className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                            type="text"
                                            name="rep_name" defaultValue={buildingData.rep_name ? buildingData.rep_name : ""}
                                            disabled={getPutPost === 'get'}
                                            onChange={updateBuilding} />
                                        {
                                            error && error.rep_name &&
                                            <p className='text-red text-xs'>{error.rep_name[0]}</p>

                                        }
                                    </div>
                                </div>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <div className='w-full flex flex-wrap items-center'>
                                            <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="rep_phone">Rep. Phone</label>
                                            <input
                                                placeholder='Rep. Phone'
                                                className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="text"
                                                name="rep_phone" defaultValue={buildingData.rep_phone ? buildingData.rep_phone : ""}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.rep_phone &&
                                                <p className='text-red text-xs'>{error.rep_phone[0]}</p>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="rep_email">Rep. Email</label>
                                        <input
                                            placeholder='Rep. Email'
                                            className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                            type="text"
                                            name="rep_email" defaultValue={buildingData.rep_email ? buildingData.rep_email : ""}
                                            disabled={getPutPost === 'get'}
                                            onChange={updateBuilding} />
                                        {
                                            error && error.rep_email &&
                                            <p className='text-red text-xs'>{error.rep_email[0]}</p>

                                        }
                                    </div>
                                </div>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <div className='w-full flex flex-wrap items-center'>
                                            <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="image">Rep. Image</label>
                                            {
                                                getPutPost === 'get' &&
                                                <img className='w-20' src={buildingData.rep_image ? buildingData.rep_image : require('../../assets/images/placeholder-image.png')} alt="" />
                                            }
                                            {getPutPost !== 'get' &&
                                                <input
                                                    className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                    type="file"
                                                    name="rep_image"
                                                    onChange={updateBuilding} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="rep_email">Data Collection Date</label>
                                        <input
                                            className='mobile:w-1/2 tablet:w-7/12 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                            type="date"
                                            name="data_collection" defaultValue={buildingData.data_collection ? buildingData.data_collection.split(" ")[0] : ""}
                                            disabled={getPutPost === 'get'}
                                            onChange={updateBuilding} />
                                        {
                                            error && error.rep_email &&
                                            <p className='text-red text-xs'>{error.rep_email[0]}</p>

                                        }
                                    </div>
                                </div>
                                <div className='input-border flex flex-wrap laptop:w-1/2 tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-nowrap items-center'>
                                        <label className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="rep_email">Has Operating Hours</label>
                                        <div className='flex flex-nowrap w-full truncate p-1 cursor-pointer' >
                                            <input className='mr-3'
                                                type="checkbox"
                                                checked={!!buildingData.has_operating_hours}
                                                onChange={updateBuilding}
                                                disabled={getPutPost === 'get'}
                                                name="has_operating_hours" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap laptop:w-full tablet:w-full mobile:w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full flex flex-wrap justify-between items-center'>
                                        <p className='mobile:w-1/2 tablet:w-4/12 text-base input-label-color' htmlFor="buildings">Operators</p>
                                        <div className='flex flex-wrap w-full text-sm p-2 outline-none overflow-hidden truncate'>
                                            {buildingData.operators ? buildingData.operators.map((e, idx) => (
                                                <div key={idx + "selectedbuildings"} className='flex flex-nowrap items-center w-content'>
                                                    <div className={`rouned-full active-user`}></div>
                                                    <p className='whitespace-nowrap'>
                                                        {e.op_name}
                                                    </p>
                                                </div>

                                            )) : ""}
                                        </div>
                                        {getPutPost !== 'get' &&
                                            <div className='flex flex-nowrap tablet:w-2/12 mobile:w-full justify-center items-center cursor-pointer mt-4' onClick={() => setManager(!manager)}>
                                                {GlobalSVG.search()}
                                                <p className='ml-2 text-green'>Manage Operators</p>
                                            </div>}

                                        {
                                            error && error.operators &&
                                            <p className='text-red text-xs'>{error.operators[0]}</p>

                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full'>
                                        <p className='w-full text-xl input-label-color mb-2' >Conservation Goals</p>
                                        <div className='w-full flex flex-wrap items-center ml-2'>
                                            <label className='mobile:w-1/2 tablet:w-2/12 text-base input-label-color' htmlFor="cons_dollar_goal">Dollar Value</label>
                                            <input
                                                placeholder='cons_dollar_goal'
                                                className='mobile:w-1/2 tablet:w-1/12 mb-1 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="number"
                                                step="0.1"
                                                name="cons_dollar_goal"
                                                value={buildingData.cons_dollar_goal ? buildingData.cons_dollar_goal : 0}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.cons_dollar_goal &&
                                                <p className='text-red text-xs'>{error.cons_dollar_goal[0]}</p>

                                            }
                                        </div>
                                        <div className='w-full flex flex-wrap items-center ml-2'>
                                            <label className='mobile:w-1/2 tablet:w-2/12 text-base input-label-color' htmlFor="cons_co_goal">t CO₂e Value</label>
                                            <input
                                                placeholder='cons_co_goal'
                                                className='mobile:w-1/2 tablet:w-1/12 mb-1 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="number"
                                                step="0.1"
                                                name="cons_co_goal"
                                                value={buildingData.cons_co_goal ? buildingData.cons_co_goal : 0}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.cons_co_goal &&
                                                <p className='text-red text-xs'>{error.cons_co_goal[0]}</p>

                                            }
                                        </div>
                                        <div className='w-full flex flex-wrap items-center ml-2'>
                                            <label className='mobile:w-1/2 tablet:w-2/12 text-base input-label-color' htmlFor="cons_kwh_goal">kWh Value</label>
                                            <input
                                                placeholder='cons_kwh_goal'
                                                className='mobile:w-1/2 tablet:w-1/12 mb-1 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="number"
                                                step="0.1"
                                                name="cons_kwh_goal"
                                                value={buildingData.cons_kwh_goal ? buildingData.cons_kwh_goal : 0}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.cons_kwh_goal &&
                                                <p className='text-red text-xs'>{error.cons_kwh_goal[0]}</p>

                                            }
                                        </div>
                                        <div className='w-full flex flex-wrap items-center ml-2'>
                                            <label className='mobile:w-1/2 tablet:w-2/12 text-base input-label-color' htmlFor="cons_kva_goal">kVA Value</label>
                                            <input
                                                placeholder='cons_kva_goal'
                                                className='mobile:w-1/2 tablet:w-1/12 mb-1 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="number"
                                                step="0.1"
                                                name="cons_kva_goal"
                                                value={buildingData.cons_kva_goal ? buildingData.cons_kva_goal : 0}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.cons_kva_goal &&
                                                <p className='text-red text-xs'>{error.cons_kva_goal[0]}</p>

                                            }
                                        </div>
                                        <div className='w-full flex flex-wrap items-center ml-2'>
                                            <label className='mobile:w-1/2 tablet:w-2/12 text-base input-label-color' htmlFor="cons_water_l_goal">Water Value (L)</label>
                                            <input
                                                placeholder='cons_water_l_goal'
                                                className='mobile:w-1/2 tablet:w-1/12 mb-1 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="number"
                                                step="0.1"
                                                name="cons_water_l_goal"
                                                value={buildingData.cons_water_l_goal ? buildingData.cons_water_l_goal : 0}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.cons_water_l_goal &&
                                                <p className='text-red text-xs'>{error.cons_water_l_goal[0]}</p>

                                            }
                                        </div>
                                        <div className='w-full flex flex-wrap items-center ml-2'>
                                            <label className='mobile:w-1/2 tablet:w-2/12 text-base input-label-color' htmlFor="cons_gas_ft_goal">Gas Value (ft³)</label>
                                            <input
                                                placeholder='cons_gas_ft_goal'
                                                className='mobile:w-1/2 tablet:w-1/12 mb-1 mr-2 text-base input-color p-2 outline-none hide-input-background'
                                                type="number"
                                                step="0.1"
                                                name="cons_gas_ft_goal"
                                                value={buildingData.cons_gas_ft_goal ? buildingData.cons_gas_ft_goal : 0}
                                                disabled={getPutPost === 'get'}
                                                onChange={updateBuilding} />
                                            {
                                                error && error.cons_gas_ft_goal &&
                                                <p className='text-red text-xs'>{error.cons_gas_ft_goal[0]}</p>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap w-full'>
                                <div className='input-border flex flex-wrap w-full items-center pt-3 pb-3 mb-6'>
                                    <div className='w-full'>
                                        <p className='w-full text-base input-label-color' htmlFor="buildings">Notes</p>
                                        <textarea className="w-full" name="notes" onChange={updateBuilding}>
                                            {buildingData.notes}
                                        </textarea>
                                        {
                                            error && error.rep_email &&
                                            <p className='text-red text-xs'>{error.rep_email[0]}</p>

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            ['get'].includes(getPutPost) &&
                            <div className='w-full flex flex-nowrap justify-end text-green4 p-2.5'>
                                <p className='cursor-pointer' onClick={() => setGetPutPost('put')}>
                                    Edit Building
                                </p>
                            </div>
                        }
                        <div className="flex flex-nowrap items-center justify-end w-full">
                            {
                                ['put'].includes(getPutPost) && !loading &&
                                <div className='mr-8 text-green3 cursor-pointer' onClick={() => setGetPutPost('get')}>
                                    Cancel
                                </div>
                            }
                            {
                                getPutPost !== 'get' && buildingData.building !== "" && !loading && <button className='submit-button' onClick={postBuilding}>
                                    Save
                                </button>
                            }
                        </div>
                    </div>
                }
            </div>
            {
                manager &&
                <div className='fixed w-screen h-screen top-0 left-0 modal-background flex flex-nowrap justify-center items-center'>
                    <div className='card laptop:w-2/5 tablet:w-3/5 mobile:w-11/12 m-2 p-4 background-white'>
                        <div className='laptop:h-[400px] tablet:h-[400px] mobile:h-[350px] overflow-auto m-2'>
                            {operators && operators.map((e, idx) => (
                                <div className='flex flex-nowrap w-full truncate p-1 cursor-pointer' key={idx + "buildings"} onClick={() => updateOperators(e)}>
                                    <input className='mr-3' type="checkbox" checked={buildingData.operators.map(i => i.operator_id).includes(e.operator_id)} />
                                    <p>{e.op_name}</p>
                                </div>
                            ))}
                        </div>
                        <div className="flex flex-nowrap items-center justify-end w-full">
                            <div className='mr-8 text-green3 cursor-pointer' onClick={() => setManager(false)}>
                                Done
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default Building;